import { CalendarIcon, Flex, InputWrap, Popover } from '@libs/ui/ds'
import { InputBase } from '@libs/ui/ds/lib/components/inputs/InputBase/base/InputBase'
import type { FC, ForwardedRef } from 'react'

import { CalendarRangeArrow } from '../../../../../datePickerUtils/subs/CalendarRangeArrow'
import { DatePickerInputClearButton } from '../../../../../datePickerUtils/subs/DatePickerInputClearButton'

import type { DateRangeTargetInputLikeProps } from './DateRangeTargetInputLike.types'

export const DateRangeTargetInputLike: FC<DateRangeTargetInputLikeProps> = ({
  dateRangeSync,
  placeholder,
  className,
  label,
  desc,
  required,
  clearable,
  errorMessage,
  pickerOnly,
  rightSection,
  onClear,
  readOnly = false,
  disabled = false,
  ref
}) => {
  return (
    <InputWrap
      label={label}
      disabled={disabled}
      className={className}
      required={required}
      errorMessage={errorMessage || dateRangeSync.errorMessage}
      desc={desc}
      field={
        <Popover.Target>
          <Flex
            row
            className='flex-nowrap items-center gap-2'
            ref={ref as ForwardedRef<HTMLDivElement>}
          >
            <InputBase
              data-testid='date-picker-input-start'
              className='grow'
              value={dateRangeSync.strValue?.start}
              onChange={e => {
                dateRangeSync.onChangeStart(e.target.value)
              }}
              type='date'
              onClick={e => e.preventDefault()}
              placeholder={placeholder}
              readOnly={readOnly || pickerOnly}
              disabled={disabled}
              error={Boolean(errorMessage || dateRangeSync.errorMessage)}
              leftIcon={<CalendarIcon />}
              rightSection={
                <DatePickerInputClearButton
                  disabled={disabled}
                  fallback={rightSection}
                  clearable={clearable}
                  readOnly={readOnly}
                  onClear={e => {
                    onClear?.(e)
                    dateRangeSync.resetStart()
                  }}
                />
              }
            />
            <CalendarRangeArrow />
            <InputBase
              data-testid='date-picker-input-end'
              className='grow'
              value={dateRangeSync.strValue?.end}
              onChange={e => dateRangeSync.onChangeEnd(e.target.value)}
              type='date'
              placeholder={placeholder}
              readOnly={readOnly || pickerOnly}
              disabled={disabled}
              onClick={e => e.preventDefault()}
              error={Boolean(errorMessage || dateRangeSync.errorMessage)}
              leftIcon={<CalendarIcon />}
              rightSection={
                <DatePickerInputClearButton
                  readOnly={readOnly}
                  disabled={disabled}
                  fallback={rightSection}
                  clearable={clearable}
                  onClear={e => {
                    onClear?.(e)
                    dateRangeSync.resetEnd()
                  }}
                />
              }
            />
          </Flex>
        </Popover.Target>
      }
    />
  )
}
